import * as types from "../constants/ylf_constants";

const initialState = {
  products: [],
  registration: null,
  ylfError: null,
  message: null,
};

const ylfReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_YLF_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: payload?.ylf || [],
        ylfError: null,
      };

    case types.REGISTER_YLF_SUCCESS:
      return {
        ...state,
        products: payload?.ylf || state.products,
        registration: payload?.registration || null,
        message: payload?.message || "Registration successful.",
        ylfError: null,
      };

    case types.GET_YLF_PRODUCTS_FAILURE:
    case types.REGISTER_YLF_FAILURE:
      return {
        ...state,
        ylfError: payload || null,
      };

    default:
      return state;
  }
};

export default ylfReducer;
